import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <div className="footer-logo">
            <h3>🐾 Woofly</h3>
            <p className="tagline">Paws United</p>
          </div>
          <p className="footer-mission">
            Bringing communities together to help street dogs in India, one city at a time.
          </p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/ngos">NGO Directory</Link></li>
            <li><Link to="/dogs">Dogs</Link></li>
            <li><Link to="/brands">Brand Partnerships</Link></li>
            <li><Link to="/about">About Us</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Get Involved</h4>
          <ul className="footer-links">
            <li><Link to="/how-to-help">Donate</Link></li>
            <li><Link to="/how-to-help">Volunteer</Link></li>
            <li><Link to="/brands">Partner With Us</Link></li>
            <li><Link to="/how-to-help">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Connect With Us</h4>
          <div className="social-links">
            <a href="#" className="social-link">📧 Email</a>
            <a href="#" className="social-link">📱 WhatsApp</a>
            <a href="#" className="social-link">📘 Facebook</a>
            <a href="#" className="social-link">📷 Instagram</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2024 Woofly. All rights reserved. 🐾</p>
      </div>
    </footer>
  );
};

export default Footer; 